export const getIsMirageInjected = (): boolean => {
  return !!(window as any)?.mirage
}
